<div class="h-full w-full flex flex-col items-center bg-gradient-to-b from-[#FFF9E6] to-[#FFF0C2] font-sans relative overflow-hidden">
  
  <div class="absolute top-0 right-0 w-64 h-64 bg-yellow-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2"></div>
  <div class="absolute bottom-0 left-0 w-64 h-64 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 translate-y-1/2 -translate-x-1/2"></div>

  <div class="w-full max-w-md px-6 pt-6 pb-2 flex items-center justify-between z-10">
    <button 
      (click)="goback()" 
      class="w-10 h-10 bg-white/80 backdrop-blur rounded-full shadow-sm flex items-center justify-center hover:bg-white hover:shadow-md transition-all text-gray-600"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
    </button>
    <h1 class="text-xl font-bold text-gray-700 flex-1 text-center pr-10">
      {{ currentLang === "TH" ? "แนะนำเพื่อน" : "Invite Friend"}}
    </h1>
  </div>

  <div class="w-full max-w-md px-6 pb-8 z-10 flex-1 flex flex-col space-y-6">
    
    <div class="bg-white rounded-2xl shadow-lg shadow-gray-100/50 p-1 overflow-hidden">
        <div class="bg-yellow-400 bg-opacity-40 rounded-xl p-6 flex items-center justify-between border border-yellow-100">
            <div class="flex items-center space-x-4">
                <div class="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-yellow-500">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                    </svg>
                </div>
                <div>
                    <p class="text-xs text-gray-500 font-medium uppercase tracking-wider">
                        {{ currentLang === "TH" ? "สมาชิกทั้งหมด" : "All Members"}}
                    </p>
                    <p class="text-sm text-gray-400">
                        {{ currentLang === "TH" ? "ที่คุณแนะนำ" : "Referred by you"}}
                    </p>
                </div>
            </div>
            <div class="text-right">
                <span class="text-3xl font-bold text-gray-800">{{ totalReferrals || 0 }}</span>
                <span class="text-xs text-gray-500 block">{{ currentLang === "TH" ? "คน" : "Users" }}</span>
            </div>
        </div>
    </div>

    <div class="bg-white rounded-2xl shadow-xl shadow-gray-200/50 p-6 space-y-6">
        
        <div class="text-center space-y-1">
             <h3 class="text-lg font-bold text-gray-700">{{ currentLang === "TH" ? "แชร์ให้เพื่อน" : "Share with friends"}}</h3>
             <p class="text-sm text-gray-400">{{ currentLang === "TH" ? "ส่งลิงก์หรือรหัสให้เพื่อนของคุณ" : "Send link or code to your friends"}}</p>
        </div>

        <div class="flex p-1 bg-gray-100 rounded-xl relative">
            <button 
                class="flex-1 py-2 text-sm font-semibold rounded-lg transition-all duration-300 z-10"
                [ngClass]="activeTab === 'link' ? 'bg-white text-yellow-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'"
                (click)="activeTab = 'link'"
            >
                {{ currentLang === "TH" ? "ลิงค์แนะนำ" : "Invite Link"}}
            </button>
            <button 
                class="flex-1 py-2 text-sm font-semibold rounded-lg transition-all duration-300 z-10"
                [ngClass]="activeTab === 'code' ? 'bg-white text-yellow-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'"
                (click)="activeTab = 'code'"
            >
                {{ currentLang === "TH" ? "รหัสแนะนำ" : "Invite Code"}}
            </button>
        </div>

        <div class="space-y-4">
            
            <div *ngIf="activeTab === 'link'" class="animation-fade-in">
                <div class="flex items-center w-full bg-gray-50 border border-gray-200 rounded-xl overflow-hidden p-1 focus-within:ring-2 focus-within:ring-yellow-200 transition-all">
                    <div class="flex-1 px-3 py-2 text-sm text-gray-600 truncate font-mono bg-transparent">
                        {{ referralLink }}
                    </div>
                    <button 
                        (click)="copyToClipboard(referralLink)"
                        class="bg-white hover:bg-gray-50 text-gray-600 p-2 rounded-lg border border-gray-100 shadow-sm transition-colors"
                    >
                         <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                    </button>
                </div>
                
                <button (click)="generateQRCode()" class="mt-4 w-full bg-yellow-400 hover:bg-yellow-500 text-white font-semibold py-3 rounded-xl shadow-lg shadow-yellow-200 flex items-center justify-center space-x-2 transition-all active:scale-[0.98]">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4h-4v-4H8m13-4V7a1 1 0 00-1-1h-4.172a2 2 0 00-1.414.586l-1.828 1.828A2 2 0 019.172 9H5a1 1 0 00-1 1v4a1 1 0 001 1h2.172a2 2 0 001.414.586l1.828 1.828A2 2 0 0011.828 19H17a1 1 0 001-1v-4a1 1 0 00-1-1h-1z" />
                    </svg>
                    <span>{{ currentLang === "TH" ? "สร้าง QR Code" : "Generate QR Code" }}</span>
                </button>
            </div>

            <div *ngIf="activeTab === 'code'" class="animation-fade-in">
                <div class="flex flex-col items-center justify-center py-4 space-y-2">
                    <p class="text-sm text-gray-500">{{ currentLang === "TH" ? "รหัสของคุณคือ" : "Your code is"}}</p>
                    <div class="text-3xl font-bold tracking-widest text-gray-800">{{ referralCode }}</div>
                </div>
                 <div class="flex items-center w-full bg-gray-50 border border-gray-200 rounded-xl overflow-hidden p-1 focus-within:ring-2 focus-within:ring-yellow-200 transition-all">
                    <div class="flex-1 px-3 py-2 text-sm text-gray-600 truncate font-mono bg-transparent">
                        {{ referralCode }}
                    </div>
                    <button 
                        (click)="copyToClipboard(referralCode)"
                        class="bg-white hover:bg-gray-50 text-gray-600 p-2 rounded-lg border border-gray-100 shadow-sm transition-colors"
                    >
                         <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                    </button>
                </div>
            </div>

        </div>
    </div>
  </div>
</div>

<div
  *ngIf="isModalOpen"
  class="fixed inset-0 z-50 flex items-center justify-center p-4"
>
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" (click)="closeModal()"></div>
  
  <div class="bg-white rounded-[2rem] shadow-2xl w-full max-w-sm relative z-10 overflow-hidden animation-scale-up">
    
    <button
      class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full text-gray-500 hover:bg-red-100 hover:text-red-500 transition-colors"
      (click)="closeModal()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>

    <div class="p-8 flex flex-col items-center">
        <h2 class="text-xl text-gray-800 font-bold mb-2">
            {{ currentLang === "TH" ? "QR แนะนำเพื่อน" : "Referral QR Code" }}
        </h2>
        <p class="text-sm text-gray-400 mb-6 text-center">
             {{ currentLang === "TH" ? "ให้เพื่อนสแกนเพื่อเริ่มใช้งาน" : "Let friend scan to start using" }}
        </p>

        <div class="p-4 bg-white border-2 border-dashed border-yellow-300 rounded-xl mb-6">
             <qrcode
                [qrdata]="obfuscatedCode"
                [width]="200"
                [errorCorrectionLevel]="'M'"
            ></qrcode>
        </div>

        <div class="flex items-start space-x-2 text-red-500 bg-red-50 p-3 rounded-lg text-xs w-full">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span>
             *{{ currentLang === "TH" ? "โปรดใช้ LINE สแกนเพื่อล๊อคอิน" : "Please scan with LINE to log in." }}*
            </span>
        </div>
    </div>
    
    <button
        class="w-full py-4 bg-gray-50 text-gray-600 font-medium hover:bg-gray-100 transition-colors border-t border-gray-100"
        (click)="closeModal()"
    >
        {{ currentLang === "TH" ? "ปิดหน้าต่าง" : "Close Window" }}
    </button>
  </div>
</div>